const TAB_DRAFT_PREFIX = 'erp_tab_draft::'

const hasSessionStorage = () => (
	typeof window !== 'undefined' && !!window.sessionStorage
)

const getSessionStorage = () => {
	if (!hasSessionStorage()) return null
	return window.sessionStorage
}

export const buildTabDraftStorageKey = (tabId, storageKey) => {
	if (!tabId || !storageKey) return null
	return `${TAB_DRAFT_PREFIX}${tabId}::${storageKey}`
}

export const resolveDraftStorageKey = ({ storageKey, draftScope = 'session', tabId }) => {
	if (!storageKey) return null
	if (draftScope !== 'tab') return storageKey
	return buildTabDraftStorageKey(tabId, storageKey)
}

export const clearTabScopedDraftsForTab = (tabId) => {
	if (!tabId) return
	const storage = getSessionStorage()
	if (!storage) return

	const prefix = `${TAB_DRAFT_PREFIX}${tabId}::`
	const keysToRemove = []

	for (let index = 0; index < storage.length; index += 1) {
		const key = storage.key(index)
		if (key?.startsWith(prefix)) {
			keysToRemove.push(key)
		}
	}

	keysToRemove.forEach((key) => storage.removeItem(key))
}

export const clearAllTabScopedDrafts = () => {
	const storage = getSessionStorage()
	if (!storage) return

	const keysToRemove = []

	for (let index = 0; index < storage.length; index += 1) {
		const key = storage.key(index)
		if (key?.startsWith(TAB_DRAFT_PREFIX)) {
			keysToRemove.push(key)
		}
	}

	keysToRemove.forEach((key) => storage.removeItem(key))
}

